module.exports = {
  // COMMON,
  scheduler: {
    entities: {
      trip: {
        tripDriverVesselConflicts: {
          single_one: 'Ein Fahrer oder Fahrzeug wird zur selben Zeit für eine andere Fahrt benötigt.\n\nBetroffene Fahrtnummer: {{conflictTripIDs}}',
          single_other: '{{count}} Fahrer und / oder Fahrzeuge werden zur selben Zeit für eine andere Fahrt benötigt.\n\nBetroffene Fahrtnummer: {{conflictTripIDs}}',
          multi_one: 'Ein Fahrer oder Fahrzeug wird zur selben Zeit für andere Fahrten benötigt.\n\nBetroffene Fahrtnummern: {{conflictTripIDs}}',
          multi_other: '{{count}} Fahrer und / oder Fahrzeuge werden zur selben Zeit für andere Fahrten benötigt.\n\nBetroffene Fahrtnummern: {{conflictTripIDs}}',
        },
      },
    },
  },
  form: {
    tripProperties: {
      fieldSetHeadlines: {
        properties: 'Eigenschaften',
        client: 'Auftraggeber',
        internalNotices: 'Interne Notizen',
        offer: 'Angebot',
        costCenters: 'Kostenstellen',
        confirmation: 'Auftragsbestätigung',
        driveOrder: 'Fahrauftrag',
        invoice: 'Rechnung',
        media: 'Dokumente, Belege und Scans zur Fahrt',
      },
    },
  },
  table: {
    head: {
      trips: 'Fahrten',
      tripDriverVessels: 'Fahrer / Kennzeichen',
      tripDriverVesselConflicts: 'Mehrfachzuweisungen von Fahrern und / oder Kennzeichen',
      tripCostCenters: 'Kostenstellen',
      tripStages: 'Reiseziele / Etappen / Uhrzeiten',
      schoolVacation: 'Ferien',
      drivers: 'Fahrer',
    },
    fields: {
      tripDriverVesselStatus: {
        ok_one: 'Keine Konflikte mit anderen Fahrern oder Fahrzeugen zur selben Zeit gefunden.',
        ok_other: 'Keine Konflikte mit anderen Fahrern oder Fahrzeugen zur selben Zeit gefunden.',
        warning: {
          trip: {
            single_one: 'Ein Fahrer oder Fahrzeug wird zur selben Zeit für eine andere Fahrt benötigt.\n\nBetroffene Fahrtnummer: {{conflictTripIDs}}',
            single_other: '{{count}} Fahrer und / oder Fahrzeuge werden zur selben Zeit für eine andere Fahrt benötigt.\n\nBetroffene Fahrtnummer: {{conflictTripIDs}}',
            multi_one: 'Ein Fahrer oder Fahrzeug wird zur selben Zeit für andere Fahrten benötigt.\n\nBetroffene Fahrtnummern: {{conflictTripIDs}}',
            multi_other: '{{count}} Fahrer und / oder Fahrzeuge werden zur selben Zeit für andere Fahrten benötigt.\n\nBetroffene Fahrtnummern: {{conflictTripIDs}}',
          },
          tripDriverVessel: {
            single: 'Dieser Fahrer oder dieses Fahrzeug wird zur selben Zeit für eine andere Fahrt benötigt.\n\nBetroffene Fahrtnummer: {{conflictTripIDs}}',
            multi: 'Dieser Fahrer oder dieses Fahrzeug wird zur selben Zeit für andere Fahrten benötigt.\n\nBetroffene Fahrtnummern: {{conflictTripIDs}}',
          },
        },
      },
    }
  },



  // SPECIAL,
  modal: {
    showInsert_trips: {
      title: 'Neue Fahrt anlegen',
    },
    showEdit_trips: {
      title: 'Fahrt bearbeiten',
    },
    showInsert_tripDriverVessels: {
      title: 'Neuen Fahrer / Kennzeichen anlegen',
    },
    showEdit_tripDriverVessels: {
      title: 'Fahrer / Kennzeichen bearbeiten',
    },
    showInsert_tripCostCenters: {
      title: 'Neue Kostenstelle anlegen',
      tooltip: {
        title: 'Hinweis',
        message: 'Die automatische Preisberechnung bevorzugt das Brutto-Feld. Bei Änderungen des Steuersatzes wird also das Netto-Feld neu berechnet.',
      },
    },
    showEdit_tripCostCenters: {
      title: 'Kostenstelle bearbeiten',
      tooltip: {
        title: 'Hinweis',
        message: 'Die automatische Preisberechnung bevorzugt das Brutto-Feld. Bei Änderungen des Steuersatzes wird also das Netto-Feld neu berechnet.',
      },
    },
    showInsert_tripStages: {
      title: 'Neue Etappe anlegen',
    },
    showEdit_tripStages: {
      title: 'Etappe bearbeiten',
    },
    showDuplicateOptions_trips: {
      title: 'Optionen zum Duplizieren einer Fahrt',
      tooltip: {
        title: 'Hinweis',
        message: 'Einige Felder werden beim Duplizieren zur Sicherheit immer zurückgesetzt. Dazu gehören die Folgenden:<br><br>Rechnungsdatum, Rechnungsnummer, Tag der Lieferung und die Dokumente.',
      },
    },
    showExportOptions_trips: {
      title: 'Optionen zum Exportieren des Dienstplans',
    },
    showInsert_schoolVacation: {
      title: 'Neuen Ferien-Zeitraum anlegen',
    },
    showEdit_schoolVacation: {
      title: 'Ferien-Zeitraum bearbeiten',
    },
    showInsert_drivers: {
      title: 'Neuen Fahrer anlegen',
    },
    showEdit_drivers: {
      title: 'Fahrer bearbeiten',
    },
    // instantImageUploader: {
    //   title: 'Bild(er) hochladen',
    //   titles: {
    //     companyLogo: 'Firmen-Logo',
    //     photo: 'Foto',
    //   },
    // },
    instantFileUploader: {
      title: 'Datei(en) hochladen',
      titles: {
        tripDocuments: 'Dokumente, Belege und Scans zur Fahrt',
      },
    },
    // showInsert_costCenters: {
    //   title: 'Kostenstelle anlegen',
    // },
    // showEdit_costCenters: {
    //   title: 'Kostenstelle bearbeiten',
    // },
    credentials: {
      showReLogin: {
        title: 'Anmeldung',
        dialogText: 'Ihre Sitzung ist abgelaufen - Bitte geben Sie ihre Benutzerdaten erneut ein.',
      },
      showReset: {
        title: 'Passwort zurücksetzen',
        dialogText: 'Bitte füllen Sie das unten stehende Formular aus um ihr Passwort zurück zu setzen. Sie erhalten direkt im Anschluss eine E-Mail mit ihren neuen Zugangsdaten.',
      },
      // showRegister: {
      //   title: 'Registrieren',
      //   dialogText: 'Bitte füllen Sie das unten stehende Formular aus um sich neu zu registrieren. Sie erhalten direkt im Anschluss eine E-Mail mit ihren Zugangsdaten.',
      // },
    },
    showAdminPanel: {
      title: 'Admin Panel',
    },
  },
  hint: {
    delete: {
      really: {
        trips: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diese Fahrt irreversibel löschen möchten?',
        },
        tripDriverVessels: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diese Zuweisung von Fahrer und Kennzeichen irreversibel löschen möchten?',
        },
        tripCostCenters: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diese Kostenstelle irreversibel löschen möchten?',
        },
        tripStages: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diese Etappe irreversibel löschen möchten?',
        },
        schoolVacation: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diesen Ferien-Zeitraum irreversibel löschen möchten?',
        },
        drivers: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diesen Fahrer irreversibel löschen möchten?',
        },
      },
    },
  },
  trips: {
    summary: {
      nrOfElements: 'Sichtbare Fahrten',
      nrOfMatchingElements: 'Gefilterte Fahrten',
      nrOfAllElements: 'Alle Fahrten',
    },
    status: {
      requested: 'Anfrage',
      ordered: 'Auftrag',
      canceled: 'Storniert',
      notAvailable: 'N/A',
      flagTitle: {
        offer: {
          info: 'Angebot noch nicht verschickt',
          ok: 'Angebot verschickt',
          error: 'Angebot noch nicht verschickt',
        },
        confirmation: {
          info: 'Bestätigung noch nicht verschickt',
          ok: 'Bestätigung verschickt',
          error: 'Bestätigung noch nicht verschickt',
        },
        driveOrder: {
          info: 'Fahrauftrag noch nicht erteilt',
          ok: 'Fahrauftrag erteilt',
          error: 'Fahrauftrag noch nicht erteilt',
        },
        invoice: {
          info: 'Rechnung noch nicht verschickt',
          ok: 'Rechnung verschickt',
          error: 'Rechnung noch nicht verschickt',
        },
      },
    },
    schedulerSummary: {
      id: 'ID',
      title: 'Titel',
      timeRange: 'Zeitraum',
      numberOfPersons: 'Personen',
      clientAddress: 'Kunde',
      status: {
        head: 'Erledigt',
        offer: 'Angebot',
        confirmation: 'Auftragsbestätigung',
        driveOrder: 'Fahrauftrag',
        invoice: 'Rechnung',
      },
      internalNotices: 'Interne Notiz',
    },
    export: {
      filename: 'Dienstplan',
    },
  },
  schoolVacation: {
    summary: {
      nrOfElements: 'Sichtbare Ferien-Zeiträume',
      nrOfMatchingElements: 'Gefilterte Ferien-Zeiträume',
      nrOfAllElements: 'Alle Ferien-Zeiträume',
    },
  },
  drivers: {
    picker: {
      inactive: 'inaktiv',
    },
    summary: {
      nrOfElements: 'Sichtbare Fahrer',
      nrOfMatchingElements: 'Gefilterte Fahrer',
      nrOfAllElements: 'Alle Fahrer',
    },
  },
  document: {
    general: {
      pageNumberPrefix: 'Seite',
    },
    offer: {
      filename: '{{primaryKey}}_Angebot',
      head: 'Angebot',
      title: 'Titel',
      timeRange: 'Zeitraum',
      documentTitle: 'Angebot {{tripID}}: {{title}} {{tripStart}}',
    },
    confirmation: {
      filename: '{{primaryKey}}_Auftragsbestätigung',
      head: 'Auftragsbestätigung',
      title: 'Titel',
      timeRange: 'Zeitraum',
      documentTitle: 'Auftragsbestätigung {{tripID}}: {{title}} {{tripStart}}',
    },
    driveOrder: {
      filename: '{{primaryKey}}_Fahrauftrag',
      head: 'Fahrauftrag',
      title: 'Titel',
      timeRange: 'Zeitraum',
      documentTitle: 'Fahrauftrag {{tripID}}: {{title}} {{tripStart}}',
    },
    driveorder: {
      filename: '{{primaryKey}}_Fahrauftrag',
      head: 'Fahrauftrag',
      title: 'Titel',
      timeRange: 'Zeitraum',
      documentTitle: 'Fahrauftrag {{tripID}}: {{title}} {{tripStart}}',
    },
    invoice: {
      filename: '{{primaryKey}}_Rechnung',
      head: 'Rechnung',
      title: 'Titel',
      timeRange: 'Zeitraum',
      documentTitle: 'Rechnung {{tripID}}: {{title}} {{tripStart}}',
    },
  //   shippingOrder: {
  //     head: 'LIEFERSCHEIN',
  //     number: 'LNr.: {{value}}',
  //     customerNumber: 'KNr.: {{value}}',
  //     projectTitle: 'Projekt',
  //     timeRange: 'Zeitraum',
  //     customerReference: 'Kunden-Referenz',
  //   },
  //   invoice: {
  //     head: 'RECHNUNG',
  //     number: 'RNr.: {{value}}',
  //     customerNumber: 'KNr.: {{value}}',
  //     projectTitle: 'Projekt',
  //     timeRange: 'Zeitraum',
  //     customerReference: 'Kunden-Referenz',
  //     vat: '{{value}} % USt.',
  //     sum: 'Rechnungssumme',
  //     overtime: 'inkl. {{durationOvertime}} Überstunden pro Person a {{hourlyRateOvertimePremium}} € pro Stunde im Wert von {{netPriceOvertimePremium}} €.',
  //     scale: 'pauschal',
  //     mail: {
  //       subject: 'Rechnung {{number}}',
  //     },
  //   },
  },
  // statusFlags: {
  //   severity: {
  //     ok: 'OK',
  //     info: 'Info',
  //     warning: 'Warnung',
  //     error: 'Fehler',
  //   },
  //   summary: {
  //     nrOfElements: 'Sichtbare Status-Elemente',
  //     nrOfMatchingElements: 'Gefilterte Status-Elemente',
  //     nrOfAllElements: 'Alle Status-Elemente',
  //   },
  // },
  // invoiceSummary: {
  //   head: {
  //     nrOfCostCenters: 'Anzahl der Kostenstellen:',
  //     netPrice: 'Preis (netto):',
  //     vatPrice: 'zzgl. MwSt.:',
  //     price: 'Preis (brutto):',
  //   },
  // },
  // dashboard: {
  //   tooltips: {
  //     documents: {
  //       message: 'Hier werden alle nicht abgerechneten Lieferscheine angezeigt.<br><br>Das Diagramm zeigt wie viele Lieferscheine mit Terminen seit Montag letzter Woche bereits bestätigt abgerechnet wurden.',
  //     },
  //   },
  //   elements: {
  //     title: {
  //       documents: 'Dokumente',
  //     },
  //   },
  // },



  // USER COMMUNICATION,
}